// src/actions/vacationActions.js
import api from '../api/axios';
import {
  FETCH_VACATIONS_REQUEST,
  FETCH_VACATIONS_SUCCESS,
  FETCH_VACATIONS_FAILURE,

  FETCH_VACATIONS_POOL_REQUEST,
  FETCH_VACATIONS_POOL_SUCCESS,
  FETCH_VACATIONS_POOL_FAIL,

  CREATE_VACATION_REQUEST,
  CREATE_VACATION_SUCCESS,
  CREATE_VACATION_FAIL,

  DELETE_VACATION_REQUEST,
  DELETE_VACATION_SUCCESS,
  DELETE_VACATION_FAIL,

  UPDATE_VACATION_REQUEST,
  UPDATE_VACATION_SUCCESS,
  UPDATE_VACATION_FAIL
} from '../constants/vacationConstants';

export const fetchVacationPool = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_VACATIONS_POOL_REQUEST });

    const { data } = await api.get('/vacation/pool/');

    dispatch({
      type: FETCH_VACATIONS_POOL_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: FETCH_VACATIONS_POOL_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};

export const fetchVacations = (page = 1) => async (dispatch) => {
  dispatch({ type: FETCH_VACATIONS_REQUEST });

  try {
    const { data } = await api.get(`/vacation/my-vacations/?page=${page}`);

    dispatch({
      type: FETCH_VACATIONS_SUCCESS,
      payload: {
        results: data.results,
        count: data.count,
        next: data.next,
        previous: data.previous,
        current: page
      }
    });

  } catch (error) {
    dispatch({
      type: FETCH_VACATIONS_FAILURE,
      payload: error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message,
    });
  }
};

// Wczytaj WSZYSTKIE urlopy dla kalendarza (bez paginacji)
export const fetchAllVacations = () => async (dispatch) => {
  dispatch({ type: FETCH_VACATIONS_REQUEST });

  try {
    const { data } = await api.get('/vacation/my-vacations/?page_size=1000');

    dispatch({
      type: FETCH_VACATIONS_SUCCESS,
      payload: {
        results: data.results || data,
        count: data.count || (data.results ? data.results.length : 0),
        next: data.next || null,
        previous: data.previous || null,
        current: 1
      }
    });

  } catch (error) {
    dispatch({
      type: FETCH_VACATIONS_FAILURE,
      payload: error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message,
    });
  }
};

export const createVacation = (startDate, endDate, vacationType) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_VACATION_REQUEST });

    await api.post('/vacation/my-vacations/create/', {
      start_date: startDate,
      end_date: endDate,
      vacation_type: vacationType
    });

    dispatch({ type: CREATE_VACATION_SUCCESS });

    dispatch(fetchVacations());
    dispatch(fetchVacationPool());
  } catch (error) {
    dispatch({
      type: CREATE_VACATION_FAIL,
      payload: error.response?.data?.non_field_errors?.[0] || error.message
    });
  }
};

export const deleteVacation = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_VACATION_REQUEST });

    await api.delete(`/vacation/my-vacations/delete/${id}/`);

    dispatch({ type: DELETE_VACATION_SUCCESS });
    dispatch(fetchVacations());
    dispatch(fetchVacationPool());
  } catch (error) {
    dispatch({
      type: DELETE_VACATION_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};

export const updateVacation = (vacation) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_VACATION_REQUEST });

    const { data } = await api.put(
      `/vacation/my-vacations/update/${vacation.id}/`,
      vacation
    );

    dispatch({
      type: UPDATE_VACATION_SUCCESS,
      payload: data,
    });

    dispatch(fetchVacations());
    dispatch(fetchVacationPool());
  } catch (error) {
    let message = 'Wystąpił błąd podczas aktualizacji.';

    if (error.response && error.response.data) {
      const data = error.response.data;

      if (data.non_field_errors) {
        message = data.non_field_errors.join(', ');
      } else if (data.detail) {
        message = data.detail;
      } else if (typeof data === 'string') {
        message = data;
      } else {
        message = Object.values(data).flat().join(', ');
      }
    } else if (error.message) {
      message = error.message;
    }

    dispatch({
      type: UPDATE_VACATION_FAIL,
      payload: message,
    });
  }
};